export const termsContent = (
    <>
        <h3>1. Acceptance of Terms</h3>
        <p>By accessing or using the Ghost-Flash-USDT protocol, you agree to be bound by these Terms of Service. If you do not agree, you must not use our services.</p>

        <h3>2. Protocol Usage</h3>
        <p>You acknowledge that Flash USDT provides experimental blockchain technology. You understand the risks associated with cryptocurrency transactions, including but not limited to network congestion, gas price fluctuations, and irreversible transactions.</p>

        <h3>3. No Financial Advice</h3>
        <p>The information provided on this platform does not constitute investment advice, financial advice, trading advice, or any other sort of advice. You should treat the content as informational only.</p>

        <h3>4. Limitation of Liability</h3>
        <p>Ghost-Flash-USDT developers and contributors shall not be held liable for any damages arising out of or in connection with your use of the protocol. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>

        <h3>5. Modifications</h3>
        <p>We reserve the right to modify these terms at any time. Continued use of the protocol after any such changes constitutes your acceptance of the new Terms of Service.</p>
    </>
)

export const privacyContent = (
    <>
        <h3>1. No Data Collection</h3>
        <p>Ghost-Flash-USDT operates on a strict no-account, no-KYC basis. We do not collect, store, or process your personal information, IP addresses, or browsing behavior.</p>

        <h3>2. On-Chain Privacy</h3>
        <p>While we do not collect data, please be aware that all blockchain transactions are public. Your wallet address and transaction history are visible on the respective blockchain explorers.</p>

        <h3>3. Local Storage</h3>
        <p>We use your browser's local storage solely to improve your user experience, such as remembering your theme preferences or temporary order details. This data never leaves your device and can be cleared at any time.</p>

        <h3>4. Third-Party Services</h3>
        <p>Our platform may interact with third-party blockchain nodes or APIs to broadcast transactions. These services are independent and have their own privacy policies.</p>
    </>
)
